import { useOnValueChange } from '@calendly/hooks'
import { FullStoryExclude } from '@calendly/ui/components/fullstory-privacy'
import { Loader } from '@calendly/ui/components/loader'
import { useRef, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { setCurrentContactProfile, useFetchContactByEmailQuery, isContactDrawerOpenSelector } from 'features/contacts'

import { AvatarDropdown } from './avatar_dropdown'

const ContactsSearchHandler = ({ query, onResults, onFetching, isHost }) => {
  const { data: contact, isFetching } = useFetchContactByEmailQuery(query, { skip: isHost })
  useEffect(() => {
    onFetching(isFetching)
  }, [isFetching, onFetching])

  useEffect(() => {
    onResults(contact ? [contact] : [])
  }, [contact, onResults])
  return null
}

export const LegacyExternalInvitee = ({ cancelled,
  isHost,
  invitee,
  toggle }) => {
  const [contact, setContact] = useState()
  const [isFetching, setIsFetching] = useState(false)
  const handleResults = (results) => {
    setContact(results?.[0])
  }
  const displayName = contact?.name || invitee.name || invitee.email
  const isContact = Boolean(contact)
  const canShowMoreInfo = isContact || (Boolean(invitee.name && invitee.email))

  const nameButtonRef = useRef()

  const isContactDrawerOpen = useSelector(isContactDrawerOpenSelector)

  const dispatch = useDispatch()

  const [openContactDrawer, setOpenContactDrawer] = useState(false)

  useOnValueChange(isContactDrawerOpen, () => {
    if (openContactDrawer) {
      nameButtonRef.current?.focus()
    }
  })

  const handleClick = () => {
    if (!canShowMoreInfo) return

    if (isContact) {
      setOpenContactDrawer(true)
      dispatch(setCurrentContactProfile(contact))
    } else {
      toggle()
    }
  }
  return (
    <FullStoryExclude>
      <ContactsSearchHandler
        query={invitee.email}
        onResults={handleResults}
        onFetching={setIsFetching}
        isHost={isHost}
      />
      {isFetching && <Loader data-testid="contact-loader" size="small" />}
      {!isFetching && (
      <AvatarDropdown
        displayName={displayName}
        cancelled={cancelled}
        isHost={isHost}
        isContact={isContact}
        canShowMoreInfo={canShowMoreInfo}
        handleClick={handleClick}
        nameButtonRef={nameButtonRef}
      />
      )}
    </FullStoryExclude>
  )
}
